import { NextPage } from 'next'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { ElectronicConsentPage } from 'experiences/electronic-consent'

const ElectronicConsent: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<ElectronicConsentPage />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default ElectronicConsent
